import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

// Components
import LanguageSwitcher from '../../components/LanguageSwitcher';
import LogoApp1 from '../../images/logo-app-1.svg';
import UserNavigation from "../../components/Layout/UserNavigation";

const Navbar = () => {
  const { t } = useTranslation();
  const isLoggedin = useSelector((state) => state.user.isLoggedin);

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-nav">
        <h1 className="navbar-brand">
          <Link to="/editor">
            <img src={LogoApp1} alt="Podcast XML Maker" />
          </Link>
        </h1>
        <div className='d-flex align-items center'>
          <ul className="navbar-nav align-items-center">
            {!isLoggedin && (
              <>
                <li className="nav-item">
                  <Link to="/login" className="nav-link">
                    <i className="bi bi-arrow-right-square" />{" "}
                    {t('home.loginText')}
                  </Link>
                </li>
              </>
            )}
          </ul>
          <LanguageSwitcher />
          {isLoggedin && <UserNavigation />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
